import { GLASS_RADIUS_OPTIONS, GLASS_TOP_OPTIONS, glassOf } from "../../engine/layout";
import { Pick } from "./Pick";

// Frameless door glass (Tesla, Porsche, convertibles…): DigiCut draws the exposed top corners sharp, the glass is round.
// The film carries the glass's own corner radius and sits a 1/32″ hairline inside the edge. "Top edge" pushes the exposed top
// edge out to the glass when DigiCut's outline sits short of it (Model Y). Both are saved per vehicle. Two dropdowns on the Top row.
export const GlassMatchPick = ({ vehicle, onChange, disabled, framedLabel }) => {
  const g = glassOf(vehicle);
  return (
    <>
      <Pick id="glass-radius" label="Corner" value={g.r} disabled={disabled} onChange={(r) => onChange({ glass_radius: r })} options={GLASS_RADIUS_OPTIONS}
        title={`Glass corner radius — the film follows the glass's own rounded corner and sits a 1/32″ hairline inside the edge, so it fits flush with an even sliver of glass all round. Saved on this vehicle.${framedLabel ? ` Your framed-car Corner radius (${framedLabel}) is not used here.` : ""}`} />
      <Pick id="glass-top" label="Top edge" value={g.t} disabled={disabled} onChange={(t) => onChange({ glass_top: t })} options={GLASS_TOP_OPTIONS} active={g.t > 0}
        title="Top edge out to the glass — pushes the exposed top edge of each roll-up out when the template outline sits short of the glass (Model Y). 0 = cut as drawn. Saved on this vehicle; use Tools ▸ Edge offset to dial all sides." />
    </>
  );
};
